"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7086],{

/***/ 50566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_NavbarBase; }
});

// UNUSED EXPORTS: UserMenu

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 3 modules
var Hidden = __webpack_require__(53450);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js + 4 modules
var Menu = __webpack_require__(48184);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AccountCircle.js
var AccountCircle = __webpack_require__(19814);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Phone.js
var Phone = __webpack_require__(69193);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/qualification/hooks/useCurrentUser.ts + 1 modules
var useCurrentUser = __webpack_require__(866);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/hooks/useAuthentication.ts
var useAuthentication = __webpack_require__(10045);
// EXTERNAL MODULE: ./src/shared/services/trustedShops/handleRatings.ts
var handleRatings = __webpack_require__(95046);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
;// CONCATENATED MODULE: ./src/shared/svg/TrustedShopsLogoBlack.js


function TrustedShopsLogoBlack(param) {
    var _height = param.height, height = _height === void 0 ? "24" : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "etrusted-logo",
            d: "M5.785,15.972A10.082,10.082,0,1,0,15.868,5.891,10.082,10.082,0,0,0,5.785,15.972ZM0,16.023a16,16,0,1,1,16,16A16,16,0,0,1,0,16.023Zm18.025-5.972a1.175,1.175,0,0,1,1.18,1.308c0,2.519-2.965,4.271-5.1,4.909.446-1.753,1.626-6.216,3.921-6.216Zm-3.538,13.2c2.74,0,4.781-1.977,6.248-4.144l-.8-.606c-1.052,1.275-2.485,3-4.271,3A2.127,2.127,0,0,1,13.626,19.1a11.714,11.714,0,0,1,.191-1.817l.445-.112c2.889-.719,7.97-1.984,7.97-5.4C22.232,9.766,20,9.1,18.343,9.1,13.4,9.1,9.9,13.75,9.9,18.5c0,2.932,1.689,4.749,4.59,4.749Z",
            transform: "translate(0 -0.024)",
            fill: "#000"
        })
    });
}

// EXTERNAL MODULE: ./src/shared/svg/TrustedShopsStars.js
var TrustedShopsStars = __webpack_require__(95359);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/qualification/components/NavbarBase.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  .MuiPaper-root {\n    border-radius: 0px;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  min-height: 30px;\n  overflow: hidden;\n  text-align: left;\n  position: absolute;\n  top: 30px;\n  z-index: ",
        ";\n  padding: ",
        "px;\n  left: -80px;\n  min-width: 200px;\n  border-left: 1px solid ",
        ";\n  border-right: 1px solid ",
        ";\n  border-bottom: 1px solid ",
        ";\n  display: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  &:hover ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  padding: ",
        ";\n  cursor: pointer;\n\n  &:hover {\n    color: rgba(0, 0, 0, 0.6);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  height: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 150px;\n  height: ",
        ";\n  font-weight: ",
        ";\n  display: flex;\n  align-items: center;\n\n  & > span {\n    display: inline-flex;\n    margin-left: ",
        "px;\n    font-size: 18px;\n  }\n\n  svg {\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  text-decoration: inherit;\n  display: flex;\n  align-items: center;\n  padding-left: ",
        "px;\n\n  ",
        " {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  min-width: 70px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #737373;\n  flex-shrink: 0;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  min-height: ",
        "px;\n  padding-bottom: ",
        "px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}



















function NavbarBase(param) {
    var logoHref = param.logoHref, ratings = param.ratings, showLogin = param.showLogin, _bgcolor = param.bgcolor, bgcolor = _bgcolor === void 0 ? "inherit" : _bgcolor;
    var isMediumScreen = (0,useBreakpoints/* useBreakpointUp */._)("md");
    var mobile = !isMediumScreen;
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {
        bgcolor: bgcolor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            size: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {
                        href: logoHref
                    }),
                    isMediumScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TrustedShopsBox, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stars, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsStars/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (0,handleRatings/* formatRating */.A6)((0,handleRatings/* getRating */.h1)(ratings))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(RatingText, {
                                                children: [
                                                    "\xa0",
                                                    t("trustedShops.ratingText")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingCount, {
                                        children: t("trustedShops.ratingCount", {
                                            amount: (0,handleRatings/* formatRatingCount */.mj)((0,handleRatings/* getRatingCount */.cz)(ratings))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TSLogoBox, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedShopsLogoBlack, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            showLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenu, {
                                shortAccountText: mobile
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PhoneLink, {
                                href: constants/* CONTACT_PHONE.href */.Y.href,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                                        smDown: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            as: "span",
                                            mr: 0.5,
                                            lineHeight: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Phone/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        })
                                    }),
                                    constants/* CONTACT_PHONE.formatted */.Y.formatted
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var NavbarLogo = function(param) {
    var href = param.href;
    if (href) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogoLink, {
                id: "navbar-logo",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogoLink, {
            as: "div",
            id: "navbar-logo",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {})
        });
    }
};
var UserMenu = function(param) {
    var shortAccountText = param.shortAccountText;
    var ref = (0,useCurrentUser/* default */.Z)(), currentUserAccount = ref.currentUserAccount, loading = ref.loading;
    var logout = (0,useAuthentication/* default */.Z)().logout;
    var isLoggedIn = !loading && currentUserAccount;
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var userMenuLinks = [
        {
            href: "/start",
            label: t("common:labels.requestCatering")
        },
        {
            href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/requests"),
            label: t("common:navigation.events")
        },
        {
            href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account"),
            label: t("common:navigation.account")
        }, 
    ];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), anchorEl = ref1[0], setAnchorEl = ref1[1];
    var handleClick = function(_event) {
        setAnchorEl(buttonRef.current);
    };
    var handleClose = function() {
        setAnchorEl(null);
    };
    var buttonRef = (0,react.useRef)(null);
    if (loading) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
            children: isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                        ref: buttonRef,
                        "aria-controls": "user-menu",
                        "aria-haspopup": "true",
                        onClick: handleClick,
                        onMouseEnter: handleClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                fontSize: 14,
                                fontWeight: 500,
                                children: shortAccountText ? currentUserAccount === null || currentUserAccount === void 0 ? void 0 : currentUserAccount.firstName : "".concat(currentUserAccount === null || currentUserAccount === void 0 ? void 0 : currentUserAccount.firstName, " ").concat(currentUserAccount === null || currentUserAccount === void 0 ? void 0 : currentUserAccount.lastName)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                display: "flex",
                                alignItems: "center",
                                ml: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenu, {
                        id: "user-menu",
                        anchorEl: anchorEl,
                        keepMounted: true,
                        transitionDuration: 0,
                        anchorOrigin: {
                            vertical: 46,
                            horizontal: "left"
                        },
                        PaperProps: {
                            elevation: 0
                        },
                        open: Boolean(anchorEl),
                        onClose: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                            display: "contents",
                            onMouseLeave: function() {
                                return setAnchorEl(null);
                            },
                            children: [
                                userMenuLinks.map(function(param) {
                                    var href = param.href, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                            children: label
                                        })
                                    }, href);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                                        onClick: logout,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                                            fontWeight: 500,
                                            children: t("common:navigation.signOut")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonBase/* default */.Z, {
                id: "open-login",
                href: "".concat(urls/* CUSTOMER_APP_HOST */._R, "/account/login"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                    fontSize: 14,
                    fontWeight: 500,
                    children: t("common:navigation.signIn")
                })
            })
        })
    });
};
var StyledMenu = (0,styled_components_browser_esm["default"])(Menu/* default */.Z)(_templateObject(), function(props) {
    return props.theme.palette.grey[200];
});
var DropdownContent = styled_components_browser_esm["default"].div(_templateObject1(), function(props) {
    return props.theme.zIndex.appBar;
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.theme.palette.grey[200];
});
var DropdownItem = styled_components_browser_esm["default"].div(_templateObject2(), DropdownContent);
var MenuItem = styled_components_browser_esm["default"].li(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.spacing(0.75, 2);
});
var Navbar = styled_components_browser_esm["default"].nav(_templateObject4(), function(param) {
    var bgcolor = param.bgcolor;
    return bgcolor;
}, function(props) {
    return props.theme.navbar.height;
});
var NavbarLogoLink = styled_components_browser_esm["default"].a(_templateObject5(), function(props) {
    return props.theme.navbar.height;
}, function(props) {
    return props.theme.typography.fontWeightMedium;
}, function(props) {
    return props.theme.spacing(1);
});
var PhoneLink = styled_components_browser_esm["default"].a(_templateObject6(), function(props) {
    return props.theme.spacing(3);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var TrustedShopsBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject7());
var Stars = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject8());
var RatingText = styled_components_browser_esm["default"].span(_templateObject9());
var RatingCount = styled_components_browser_esm["default"].span(_templateObject10());
var TSLogoBox = (0,styled_components_browser_esm["default"])(esm.Box)(_templateObject11(), function(props) {
    return props.theme.spacing(1.5);
}, function(props) {
    return props.theme.spacing(0.5);
});
var Text = styled_components_browser_esm["default"].span(_templateObject12());
/* harmony default export */ var components_NavbarBase = (NavbarBase);


/***/ }),

/***/ 42149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22318);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(57833);
/* harmony import */ var qualification_components_NavbarBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50566);
/* harmony import */ var qualification_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85643);
/* harmony import */ var qualification_context_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91538);
/* harmony import */ var qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19916);
/* harmony import */ var shared_services_trustedShops_handleRatings__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(95046);
/* harmony import */ var shared_svg_TrustedShopsLogo__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36902);
/* harmony import */ var shared_svg_TrustedShopsStars__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95359);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-decoration: underline;\n  font-weight: 500;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        "px;\n  background: ",
        ";\n  position: relative;\n  max-width: 740px;\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n\n  ",
        " {\n    height: ",
        "px;\n    border-radius: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  height: ",
        "px;\n  background: ",
        ";\n  transition: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n  background-color: ",
        ";\n  color: white;\n  font-size: 12px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n  color: white;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 17px;\n  width: 100%;\n  min-width: 70px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  min-height: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}














var PROGRESS_BAR = {
    HEIGHT: {
        DESKTOP: 10,
        MOBILE: 8
    }
};
function SurveyNavbar(param) {
    var ratings = param.ratings;
    var state = (0,qualification_context__WEBPACK_IMPORTED_MODULE_6__/* .useQualification */ ._8)().state;
    var isMobile = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_10__/* .useBreakpointDown */ .a)("xs");
    var isSmallScreen = (0,qualification_hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_10__/* .useBreakpointDown */ .a)("sm");
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)("common").t;
    if (state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_7__/* .QUALIFICATION_STATUS.answering */ .w.answering && state.status !== qualification_context_model__WEBPACK_IMPORTED_MODULE_7__/* .QUALIFICATION_STATUS.answered */ .w.answered) {
        return null;
    }
    var percentageToCompletion = state.status === qualification_context_model__WEBPACK_IMPORTED_MODULE_7__/* .QUALIFICATION_STATUS.answering */ .w.answering ? state.qualification.progressPercentage : 100;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NavBarWrapper, {
                children: [
                    isSmallScreen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NavbarEyebrow, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TrustedShopsBox, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Stars, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(shared_svg_TrustedShopsStars__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Text, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                children: (0,shared_services_trustedShops_handleRatings__WEBPACK_IMPORTED_MODULE_12__/* .formatRating */ .A6)((0,shared_services_trustedShops_handleRatings__WEBPACK_IMPORTED_MODULE_12__/* .getRating */ .h1)(ratings))
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RatingText, {
                                                children: [
                                                    "\xa0",
                                                    t("trustedShops.ratingText")
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TSLogoBox, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(shared_svg_TrustedShopsLogo__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(qualification_components_NavbarBase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        ratings: ratings,
                        showLogin: true,
                        logoHref: "/"
                    })
                ]
            }),
            isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressBarTrack, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledProgressBar, {
                    $width: "".concat(percentageToCompletion, "%")
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                display: "flex",
                alignItems: "center",
                mt: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                        ml: "auto",
                        pl: 4,
                        flexShrink: 0,
                        pr: 4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TypographyBackLink, {
                                as: "a",
                                id: "close-funnel-btn",
                                children: t("labels.cancel")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ProgressBarTrack, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledProgressBar, {
                            $width: "".concat(percentageToCompletion, "%")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box, {
                        mr: "auto",
                        pr: 4,
                        pl: 4,
                        flexShrink: 0,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            children: [
                                percentageToCompletion,
                                "% ",
                                t("labels.done").toLowerCase()
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var NavBarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject(), function(props) {
    return props.theme.palette.grey[250];
});
var TypographyBackLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_templateObject1(), function(props) {
    return props.theme.palette.text.primary;
});
var ProgressBarTrack = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject2(), PROGRESS_BAR.HEIGHT.DESKTOP, function(props) {
    return props.theme.palette.grey[250];
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, PROGRESS_BAR.HEIGHT.MOBILE);
var StyledProgressBar = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].div(_templateObject3(), PROGRESS_BAR.HEIGHT.DESKTOP, function(props) {
    return props.theme.palette.primary.main;
}, function(props) {
    return props.theme.transitions.create("width", {
        duration: "250ms"
    });
}, function(props) {
    return props.$width ? props.$width : "0";
});
var NavbarEyebrow = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].section(_templateObject4(), function(props) {
    return props.theme.spacing(1.25);
}, function(props) {
    return props.theme.palette.grey[800];
});
var TrustedShopsBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject5());
var Stars = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject6());
var RatingText = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].span(_templateObject7());
var TSLogoBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_14__["default"])(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__.Box)(_templateObject8());
var Text = styled_components__WEBPACK_IMPORTED_MODULE_14__["default"].span(_templateObject9());
/* harmony default export */ __webpack_exports__["Z"] = (SurveyNavbar);


/***/ }),

/***/ 20486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      pointer-events: none;\n      color: ",
        ";\n      cursor: default;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  text-decoration: none;\n  border-radius: 4px;\n  padding: ",
        ";\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: ",
        ";\n  margin: 0 4px;\n\n  &:hover {\n    background-color: ",
        ";\n    color: black;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function Locale() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("nav", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
                className: "sr-only",
                children: "Language switcher"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "de",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "de",
                    children: "DE"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: router.asPath,
                passHref: true,
                locale: "en",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ToggleButton, {
                    selected: router.locale === "en",
                    children: "EN"
                })
            })
        ]
    });
}
var ToggleButton = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(1, 1);
}, function(props) {
    return props.theme.palette.grey[600];
}, function(props) {
    return props.theme.palette.grey[200];
}, function(props) {
    return props.selected && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__.css)(_templateObject(), function(props) {
        return props.theme.palette.common.white;
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Locale);


/***/ }),

/***/ 4285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ legalEntityName; }
/* harmony export */ });
var DEFAULT_LEGAL_ENTITY = "Hey Group GmbH";
var LEGAL_ENTITY_BY_LOCALE = {
    "en-uk": "HEYCATER! UK LTD"
};
function legalEntityName(locale) {
    return locale && LEGAL_ENTITY_BY_LOCALE[locale.toLowerCase()] || DEFAULT_LEGAL_ENTITY;
}


/***/ }),

/***/ 89452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; },
  "Z": function() { return /* binding */ layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Facebook.js
var Facebook = __webpack_require__(83792);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkedIn.js
var LinkedIn = __webpack_require__(20551);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./src/shared/components/CookieContextProvider.tsx + 1 modules
var CookieContextProvider = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/shared/components/Locale.js
var Locale = __webpack_require__(20486);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/helpers/legalEntity.ts
var legalEntity = __webpack_require__(4285);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Footer.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  display: flex;\n  align-items: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: inherit;\n  border: inherit;\n  line-height: 23px;\n  height: inherit;\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  color: white;\n  border: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: ",
        ";\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n\n  ",
        " {\n    margin: ",
        ";\n    display: flex;\n    text-decoration: none;\n    list-style: none;\n    padding: 0;\n    flex-direction: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  margin: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #9cba6c;\n  text-decoration: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
















var YEAR = new Date().getFullYear();
function Footer() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useContext)(CookieContextProvider/* CookieContext */.U), detailsOpen = ref.detailsOpen, setDetailsOpen = ref.setDetailsOpen;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            className: "main-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    alt: "",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                fontSize: 12,
                                color: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                                as: "nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "sr-only",
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.linkedin.com/company/heycater/",
                                        "aria-label": "Linkedin",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.facebook.com/heycater",
                                        "aria-label": "Facebook",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://twitter.com/HeyHeycater",
                                        "aria-label": "Twitter",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                        flexDirection: "column",
                        as: "nav",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                            mobileColumn: true,
                            as: "ul",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/impressum",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.imprint")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/agb",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.terms")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/datenschutz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.privacy")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        as: "button",
                                        onClick: function() {
                                            return setDetailsOpen(!detailsOpen);
                                        },
                                        children: "Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: constants/* LINKS.career */.BA.career,
                                        rel: "noopener",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerLink, {
                                            target: "_blank",
                                            children: t("common:navigation.career")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about-us",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: "About us"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/hub",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.blog")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/partner-page",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
                                            children: [
                                                "\uD83E\uDDD1‍\uD83C\uDF73 ",
                                                t("common:navigation.partner")
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypography, {
                        pt: 2,
                        fontSize: 12,
                        children: [
                            YEAR,
                            " ",
                            (0,legalEntity/* legalEntityName */.t)(locale)
                        ]
                    })
                ]
            })
        })
    });
}
var NavListItem = styled_components_browser_esm["default"].li(_templateObject());
var StyledLink = styled_components_browser_esm["default"].a(_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var StyledFooter = styled_components_browser_esm["default"].div(_templateObject2(), function(props) {
    return props.theme.spacing(4, 0);
}, function(props) {
    return props.theme.palette.text.primary;
});
var FooterWrapper = styled_components_browser_esm["default"].div(_templateObject3(), function(props) {
    return props.flexDirection;
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var FooterColumn = styled_components_browser_esm["default"].div(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1, 0);
}, function(props) {
    return props.mobileColumn ? "column" : "row";
});
var FooterLink = styled_components_browser_esm["default"].a(_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var FooterSocialIconLink = styled_components_browser_esm["default"].a(_templateObject6(), function(props) {
    return props.theme.spacing(0, 1.75);
});
var StyledTypography = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject7(), function(props) {
    return props.theme.palette.grey[400];
});
var CareerLink = (0,styled_components_browser_esm["default"])(FooterLink)(_templateObject8());
/* harmony default export */ var layouts_Footer = (Footer);

// EXTERNAL MODULE: ./src/shared/layouts/Navigation.tsx + 2 modules
var Navigation = __webpack_require__(48107);
;// CONCATENATED MODULE: ./src/shared/layouts/MainLayout.tsx






function MainLayout(param) {
    var children = param.children, _hideNavigationLinks = param.hideNavigationLinks, hideNavigationLinks = _hideNavigationLinks === void 0 ? false : _hideNavigationLinks, _hideNavbar = param.hideNavbar, hideNavbar = _hideNavbar === void 0 ? false : _hideNavbar, renderNavbarCta = param.renderNavbarCta, ratings = param.ratings;
    if (hideNavbar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
            main: children,
            footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* default */.Z, {
            ratings: ratings,
            hideNavigationLinks: hideNavigationLinks,
            renderCTA: renderNavbarCta
        }),
        main: children,
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
    });
}
MainLayout.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node, 
    ]).isRequired
};
var PageLayout = function(param) {
    var header = param.header, main = param.main, footer = param.footer, root = param.root;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        position: "sticky",
                        top: "0",
                        zIndex: "100",
                        style: {
                            background: "white"
                        },
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "main",
                        display: "flex",
                        overflow: "clip",
                        flexDirection: "column",
                        flexGrow: "1",
                        children: main
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        as: "footer",
                        mt: "auto",
                        children: footer
                    })
                ]
            }),
            root
        ]
    });
};
/* harmony default export */ var layouts_MainLayout = (MainLayout);


/***/ })

}]);